import i from"styled-components";const e=i.div`
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	border-radius: ${({borderRadius:i})=>`${i}px`};
	background-color: ${({backgroundColor:i})=>i};
	border: 0.71px solid ${({theme:i})=>i.border.black10};
	display: flex;
	flex-direction: ${({isOneColumn:i})=>i?"row":"column"};
	height: 100%;
	color: ${({color:i})=>i};
`,o=i.div`
	padding: 5px;
`,n=i.div`
	background: url(${({imageUrl:i})=>i});
	background-size: cover;
	background-position: ${({position:i})=>i?`${i.x}% ${i.y}%`:"center"};
	border-radius: ${({borderRadius:i})=>i-3+"px"};
	position: relative;

	${({isOneColumn:i})=>i?"\n      width: 284px;\n      height: 241px;\n      ":"\n      height: 170px;\n  "}
`,t=i.div`
	position: relative;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;

	gap: ${({isOneColumn:i})=>i?"0px":"14px"};
	justify-content: ${({isOneColumn:i})=>i?"space-around":"space-between"};
	padding: ${({isOneColumn:i})=>i?"24px 40px":"12px 14px"};
	flex: ${({isOneColumn:i})=>i?1:"0 1 auto"};
`,r=i.div`
	display: flex;
	flex-direction: column;
	gap: ${({isOneColumn:i})=>i?"0px":"14px"};
`,d=i.h1`
	margin: 0;
	max-width: 80%;
	font-size: ${({isOneColumn:i})=>i?"32px":"20px"};
	font-weight: ${({isOneColumn:i})=>i?600:500};
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
`,p=i.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	opacity: 0.4;
	width: 80%;
	white-space: pre-wrap;
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
`,l=i.div`
	opacity: 0.75;

	${({isAbsolute:i})=>i&&"\n    position: absolute;\n    bottom: 12px;\n    right: 14px;\n  "}
`,s=i.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:i})=>i};
	background: ${({background:i})=>i};
	cursor: ${({isEditable:i=!1})=>i?"text":"default"};
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	height: 26px;
	box-sizing: border-box;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,a=i.div`
	display: flex;
	justify-content: ${({hasLabel:i})=>i?"space-between":"end"};
	align-items: center;
`;export{l as CardArrowContainer,e as CardContainer,r as CardContent,t as CardContentContainer,n as CardCover,o as CardCoverContainer,a as CardFooter,d as CardHeading,s as CardLabel,p as CardParagraph};
